import React from 'react'
import { AccountStyled } from './styled'
import HeadBar from '../../../../modules/HeadBar'
import Footer from '../../../../modules/Footer'
import { Card } from '../../../../components/Card';
import Container from '../../../../components/Container';
import { useFetch } from '../../../../hooks';
import Settings from './components/Settings';
import Timezone from './components/Timezone';
// import Language from './components/Language';
import CompanyName from './components/CompanyName';
import Notifications from './components/Notifications';
import Contact from './components/Contact';

const Account = () => {

    const { response, doFetch } = useFetch({
        url: '/account',
        method: 'GET',
    })

    return (
        <AccountStyled>
            <HeadBar
                title={response.data[0] && response.data[0].account.title}
            />
            <Container>
                {response.data[0] && (
                    <Card smallPadding>
                        <CompanyName data={response.data[0].account['company_name']} refetchAccount={doFetch} />
                        <Settings data={response.data[0].account['settings']} refetchAccount={doFetch} />
                        <Timezone data={response.data[0].account['timezone']} refetchAccount={doFetch} />
                        <Notifications data={response.data[0].account['sms_notification']} refetchAccount={doFetch} />
                        <Contact data={response.data[0].account['contact']} refetchAccount={doFetch} />
                        {/* <Language data={response.data[0].account['language']} refetchAccount={doFetch} /> */}
                    </Card>
                )}
            </Container>
            <Footer />
        </AccountStyled>
    )
}

export default Account
